export default __webpack_public_path__ + "static/media/425property-gallery4.190c996d.webp";